const ProductList = {
  options: {
    data: {
      dynamicImages: [
        {
          image: {
            src: '',
          },
          pointTo: {
            url: '',
            pointTo: '',
            pointToName: '',
            pointToType: '',
          },
        },
      ],
      isDynamic: false,
    },
    customization: {},
    widgets: {},
  },
  variants: [
    {
      id: 'ProductList_Yenir',
      name: 'ProductList_Yenir',
      type: 'ProductList',
      data: {
        text: '',
        images: [],
        dynamicImages: [],
        isDynamic: false,
      },
      customization: {},
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 1,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
        dynamicRenderTabs: {
          category: 'default',
          brand: 'default',
        },
        dynamicLimitOptions: ['4', '8', '12', '16', '20'],
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/Cart_Yenir.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
  ],
};
export default ProductList;
